/* eslint-disable */
import 'jcarousel';
import 'jquery.cookie';

import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import '../atlas/css/atlas-header-withMenu.scss';
import '../atlas/css/atlas-page-sections.css';
import '@/css/desktop/search';
import '@/css/desktop/search/destination-info-atlas.css';

import AbstractSearchController from '@/js/desktop/Domain/Abstract/SearchController';
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import SocialButtons from "@/js/desktop/components/social-btns";

import initGallery from './initGallery';

var Controller = AbstractSearchController.extend({
	initGallery,
	initSocialButtons() {
		new SocialButtons({
			el: '.social-btns'
		});
	},
	initialize() {
		$.removeCookie('requestFromMainPage', {path: '/', domain: 'all'});
		tourCriteriaService.clearTourCriteriaChangedFields();

		AbstractSearchController.prototype.initialize.call(this);
		this.initGallery();
		this.initSocialButtons();
	},
});

export default Controller;
